import useAppStore from '../stores/app'

const usePermissions = () => {
  const permissions = useAppStore(state => state.permissions)
  const has = (permissionKey: string) => Object.hasOwn(permissions, permissionKey)

  return {
    has
  }
}

export default usePermissions
